import React from 'react';
import ArrowBackRounded from '@material-ui/icons/ArrowBackRounded';
import ButtonBase from '@material-ui/core/ButtonBase';
import Slide from '@material-ui/core/Slide';
import Collapse from '@material-ui/core/Collapse';

import Component from '../../../../../ui-components/Component';
import { withResizer,withUser } from '../../../../../HoCs';
import IconButton from '../../../../../ui-components/Button/Icon';
import styles from './styles';
import OTAForm from '../OTAForm';
import ManualForm from '../ManualForm';
import { createProperty, syncOta, mapFormToOtaList, fetchPropertyDetails } from './interactor';
import { handleNetworkError } from '../../../../../ui-components/utils';
import LoaderDialog from '../LoaderDialog';
import {path} from '../../../../../utils';

import { Link } from 'react-router-dom';


class OTAFlow extends Component {

    state = {
        loading: false,
        step: this.props.skipOta ? 2 : 1,
        submitOpen: false,
        submitMode: 'loading',
        fetchOpen: false,
        fetchMode: 'loading',

        propertyDetails: {},
        propertyID: this.props.id,
    };

    styles = styles;
    otaFormRef = React.createRef();
    manualFormRef = React.createRef();

    componentDidMount = () => {
        this.state.propertyID && this.fetchProperty();
        this.props.auto && !this.props.skipOta && this.onSubmit();
    };
    
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.hasPropChanged(prevProps,'prefillOta')){
            this.otaFormRef.current.mapOta(this.props.prefillOta)
        }
    }
    
    showDialog = (type, open, mode, callback) => this.setState({ [type === 'fetch' ? 'fetchOpen' : 'submitOpen']: open, [type === 'fetch' ? 'fetchMode' : 'submitMode']: mode }, callback);

    getBackRoute = () => {
        if(this.state.step === 1){
            return this.props.backRoute
        }
    };
    
    onBack = (e) => {
        if(this.state.step === 2){
            this.setState({ step: 1 });
            e.preventDefault()
        }
    };
    
    onSubmit = () => this.state.step === 1 ? this.submitOTA() : this.submitProperty();
    onSkip = () => this.setState({ step: 2 });
    
    onDialogAction = (e) => {
        if (this.state.step == 1) {
            this.setState({ fetchOpen: false, step: 2 });
            e.preventDefault()
        }
    };
    
    getDialogActionRoute = () => {
        if (this.state.step === 2) {
            return typeof this.props.finalPageRedirection === 'function' ? this.props.finalPageRedirection(this.state.propertyID):this.props.finalPageRedirection;
        }
    };
    
    dialogAction = () => {
        if(this.state.step === 1) {
            this.setState({ fetchOpen: false, step: 2 })
        }
    };

    render = () => {
        const { className, submitDialog } = this.props;
        return <div style={this.gs('container')} className={className}>
            <div style={this.gs('header')}>
                <Link to={this.getBackRoute()} onClick={this.onBack}><IconButton><ArrowBackRounded /></IconButton></Link>
                <div style={this.gs('title')}>{this.props.gc(this.props.title)}</div>
                {this.state.step === 1 && <ButtonBase style={this.gs('skip')} onClick={this.onSkip}>{this.props.gc('Skip')}</ButtonBase>}
                <ButtonBase style={this.gs('submit')} onClick={this.onSubmit}>{this.state.step === 1 ? this.props.gc('fetch_details') : this.props.gc('Submit')}</ButtonBase>
            </div>
            <div style={this.gs('content')}>
                <div style={this.gs('form')}>
                    <div style={this.gs('scrollable_header')}>
                        <Link to={this.getBackRoute()} onClick={this.onBack}><ArrowBackRounded style={this.gs('back_icon')} /></Link>
                        {this.state.step === 1 && <ButtonBase style={this.gs('skip')} onClick={this.onSkip}>{this.props.gc('Skip')}</ButtonBase>}
                    </div>
                    <div>
                        <Collapse in={this.state.step === 1}>
                            <OTAForm ref={this.otaFormRef} className='fillSpace' auto={this.props.auto} gc={this.props.gc}/>
                        </Collapse>
                        <Slide direction='left' in={this.state.step === 2} unmountOnExit>
                            <ManualForm ref={this.manualFormRef} data={this.state.propertyDetails} className='fillSpace' gc={this.props.gc}/>
                        </Slide>
                    </div>
                    <ButtonBase style={this.gs('bottom_submit')} onClick={this.onSubmit}>{this.state.step === 1 ? this.props.gc('fetch_details') : this.props.gc('Submit')}</ButtonBase>
                </div>
            </div>
            <LoaderDialog
                open={this.state.loading} mode='loading'
                loadingText='fetching_property_details'
                 />
            <LoaderDialog
                open={this.state.fetchOpen}
                mode={this.state.fetchMode}
                loadingText='fetching_property_details'
                successText='property_details_fetched'
                actionText='confirm_details'
                dialogAction={this.dialogAction}
            />
            <LoaderDialog
                open={this.state.submitOpen}
                mode={this.state.submitMode}
                loadingText={submitDialog.loadingText}
                successText={submitDialog.successText}
                actionText={submitDialog.actionText}
                actionRoute={this.getDialogActionRoute()}
            />
        </div>;
    };

    fetchProperty = () => this.setState({ loading: true }, () => fetchPropertyDetails(this.state.propertyID,
        propertyDetails => this.setState({ propertyDetails, loading: false }),
        error => this.setState({ loading: false }, () => handleNetworkError(error))
    ));

    submitOTA = () => {
        const data = this.otaFormRef.current.getAnswers(); if (data === false) return;
        this.showDialog('fetch', true, 'loading', () => syncOta(mapFormToOtaList(data),
            propertyDetails => this.showDialog('fetch', true, 'success', () => this.mergeDetails(propertyDetails)),
            error => this.showDialog('fetch', false, 'loading', () => handleNetworkError(error))
        ));
    };

    submitProperty = () => {
        let data = this.manualFormRef.current.getAnswers(true); if (data === false) return;
        if (this.state.propertyID) data = { ...data, property_unique_id: this.state.propertyID };
        this.showDialog('submit', true, 'loading', () => createProperty(data,
            propertyID => this.showDialog('submit', true, 'success', () => this.setState({ propertyID })),
            error => this.showDialog('submit', false, 'loading', () => handleNetworkError(error))
        ));
    };

    mergeDetails = (otaPropDetails) => this.setState({
        propertyDetails: {
            ...this.state.propertyDetails,
            ...otaPropDetails
            // all the properties that need to be overwritten with ota go here
            // ex: property_name: otaPropDetails.property_name,
        }
    });

}

OTAFlow.defaultProps = {
    title: 'add_a_property',
    submitDialog: {
        loadingText: 'authenticating_info',
        successText: 'property_added_successfully',
        actionText: 'view_property_details',
    },
    auto: false,
};

export default withUser(withResizer(OTAFlow));